import { type FC } from 'react';

import HtmlContent from '@/components/HtmlContent';
import convertMarkdownToHtml from '@/helpers/convertMarkdownToHtml';
import replaceTaggedUsersInHtml from '@/helpers/replaceTaggedUsersInHtml';
import type * as ApiModels from '@/typings/api-models';

import s from './RenderText.module.scss';

const ALLOWED_ATTR = ['target', 'rel', 'href', 'src', 'style', 'data-aha-moment', 'data-link-type'];

type TextProps = {
  comment: {
    text?: string | null;
    richText?: {
      html: string;
    } | null;
    taggedUsers: Pick<ApiModels.Person, 'id' | 'name'>[];
  } | null;
};

const RenderText: FC<TextProps> = ({ comment }) => {
  let message = comment?.richText?.html || comment?.text?.replace(/\r?\n/g, '<br />') || '';
  const taggedUsers = comment?.taggedUsers || [];

  if (!message) {
    return null;
  }

  message = convertMarkdownToHtml(message);
  message = replaceTaggedUsersInHtml({ message, taggedUsers });

  return <HtmlContent className={s.text} content={message} allowedAttr={ALLOWED_ATTR} />;
};

export default RenderText;
